













































import { Component, Vue, Prop } from 'vue-property-decorator';
import Typography from '@/components/atoms/Typography/Typography.vue';
import IconPerson from '@/components/icons/UserWithBorder.vue';
import IconAmount from '@/components/icons/Amount.vue';
import IconCoins from '@/components/icons/Coins.vue';
import CreditCardIcon from '@/components/icons/CreditCard.vue';
import { LoyaltyStatus } from '@/models/performance';
import { upperCaseFirstLetter } from '@/utils/string';

export enum ETypeInfoItem {
  CUSTOMER = 'customer',
  MONEY_AMOUNT = 'money-amount',
  COINS_AMOUNT = 'coins-amount',
  CREDIT_CARD_INFO = 'credit-card-info'
}

@Component<ItemPurchaseInfoTransaction>({
  components: {
    Typography,
    IconPerson,
    IconAmount,
    IconCoins,
    CreditCardIcon
  }
})
export default class ItemPurchaseInfoTransaction extends Vue {
  @Prop() type!: ETypeInfoItem;
  @Prop() text!: string;
  @Prop() loyaltyStatus?: LoyaltyStatus;

  ETypeInfoItem = ETypeInfoItem;
  upperCaseFirstLetter = upperCaseFirstLetter;

  getClassBadgeLayoutStatus(): string {
    switch (this.loyaltyStatus) {
      case LoyaltyStatus.COMPLETED:
        return 'green';
      case LoyaltyStatus.PENDING:
        return 'orange';
      case LoyaltyStatus.CANCELED:
        return 'red';
      default:
        return 'none';
    }
  }
}
